import createCloseFormDefaults from './index';
import { actions as parentActions } from '../../item';
import translation from '../../../../config/translation';

const createCloseForm = ({
	namespace,
	stateNodeName
}) => {
	const closeFormDefaults = createCloseFormDefaults({ namespace, stateNodeName });
	return {
		...closeFormDefaults,
		actions: {
			...closeFormDefaults.actions,
			closeFormSubmit: formData => (dispatch, getState) => {
				const { data: { ticket: { id } } } = getState()['threadsItem'];
				dispatch(parentActions.close([id], formData.closeMessage));
				dispatch(closeFormDefaults.actions.toggleCloseForm());
			}
		},
		selectors: {
			...closeFormDefaults.selectors,
			getInitialValues: state => {
				if (!state.threadsItem.affiliate ) return;

				const translatorKey = state[namespace][stateNodeName].formInitialValues.closeMessage;
				const { threadsItem: { affiliate: { language } } } = state;

				const closeMessage = (translation[translatorKey] && translation[translatorKey][language])
					? translation[translatorKey][language]
					: translatorKey;

				return {
					...state[namespace][stateNodeName].formInitialValues,
					closeMessage
				};
			}
		}
	};
};

export default createCloseForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/close-form/for-thread-item.js